// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__zfOsC","banner-content":"styles_banner-content__DrB1q","banner-image":"styles_banner-image__dRqd6"};